// extracted by mini-css-extract-plugin
export var contentBody = "_6q-9";
export var headerImage = "_6q-2";
export var imageButton = "_6q-7";
export var imageButtonIcon = "_6q-8";
export var imageHeader = "_6q-4";
export var imageHeaderText = "_6q-5";
export var imageOverlay = "_6q-3";
export var imageTitle = "_6q-6";
export var imageWrapper = "_6q-1";
export var taskList = "_6q-a";
export var widget = "_6q-0";